module.exports = __webpack_public_path__ + "img/9788994077239.52790552.jpg";